import { CarrierAccount } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const renameCarrierAccount = {
  name: "renameCarrierAccount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    /** The account's `_id`, not its `carrierAccountId`. */
    carrierAccountObjectId: z.string(),
    name: z.string(),
  }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
